<template>
  <div class="image-upload-post">
    <span class="image-upload-post__title">ваши образы в lassie</span>

    <span class="image-upload-post__subtitle">
      Отмечайте
      <span class="image-upload-post__subtitle--bold"> @lassie_russia </span>
      в соцсетях или загружайте на сайте и ваши образы появятся здесь
    </span>

    <SimpleButton
      class="frisbuy-lassie-iu-banner__btn"
      widget-iu-button="true"
      onclick="iuWidget.open()"
    >
      Добавить свой образ
    </SimpleButton>
  </div>
</template>

<style scoped lang="scss">
$lassiePrimaryColor: #002354;

.image-upload-post {
  width: 100%;
  height: 100%;

  &__title,
  &__subtitle {
    display: block;

    color: $lassiePrimaryColor;
  }

  &__title {
    font-family: Factor A, sans-serif;
    font-size: 32px;
    font-weight: 400;
    line-height: 1.5em;

    text-transform: uppercase;
  }

  &__subtitle {
    font-family: Factor A Light, sans-serif;
    font-size: 18px;
    font-weight: 300;

    color: #252d37;

    margin-top: 16px;

    &--bold {
      font-family: Factor A, sans-serif;
      font-weight: 400;
    }
  }

  .frisbuy-lassie-iu-banner__btn {
    max-width: 225px;

    font-family: Factor A, sans-serif;
    font-size: 16px;
    font-weight: 400;

    padding-right: 0;
    padding-left: 0;

    margin-top: 24px;
  }
}

// media queries
.image-upload-post {
  container-type: inline-size;
  min-width: 96px;

  @container (width < 260px) {
    &__title {
      font-size: 24px;
    }

    &__subtitle {
      font-size: 14px;
      margin-top: 10px;
    }

    .frisbuy-lassie-iu-banner__btn {
      font-size: 12px;

      margin-top: 16px;
    }
  }

  @container (width < 200px) {
    &__title {
      font-size: 18px;
    }

    &__subtitle {
      display: none;
    }

    .frisbuy-lassie-iu-banner__btn {
      font-size: 10px;
    }
  }

  @container (width < 130px) {
    &__title {
      font-size: 14px;
    }

    .frisbuy-lassie-iu-banner__btn {
      font-size: 8px;
    }
  }
}
</style>

<script>
import SimpleButton from "@/clients/lassie_infinity_images/components/SimpleButton.vue";

export default {
  components: {
    SimpleButton,
  },

  data() {
    return {};
  },
};
</script>
